import { Injectable } from "@angular/core";
import { ReasonsType } from "./critical-area-window.component";
import { IReasons, ProbabilityOfFailure } from "./critical-area.model";

@Injectable({
  providedIn: 'root'
})
export default class POFCategorization {
  categorizeFEA(percentage: number, type: "Yielding" | "Buckling" | "Fatigue"): ProbabilityOfFailure {
    if(percentage == null) {
      return null
    }
    if (percentage >= 0.01) {
      return ProbabilityOfFailure.VERY_LIKELY;
    } else if (percentage >= 0.001) {
      return ProbabilityOfFailure.LIKELY;
    } else if (percentage >= 0.0001) {
      return ProbabilityOfFailure.POSSIBLE;
    } else if (percentage >= 0.00001) {
      return ProbabilityOfFailure.UNLIKELY;
    } else {
      return ProbabilityOfFailure.RARE;
    }
  }
  categorizeRelativeDegradation(percentage: number): ProbabilityOfFailure {
    if(percentage == null) {
      return null
    }
    if (percentage <= 25) {
      return ProbabilityOfFailure.RARE;
    } else if (percentage <= 50) {
      return ProbabilityOfFailure.UNLIKELY;
    } else if (percentage <= 75) {
      return ProbabilityOfFailure.POSSIBLE;
    } else if (percentage <= 100) {
      return ProbabilityOfFailure.LIKELY;
    } else {
      return ProbabilityOfFailure.VERY_LIKELY;
    }
  }

  categorizeRemainingLife(yearsInPercentage: number): ProbabilityOfFailure {
    if(yearsInPercentage == null) {
      return null
    }
    if (yearsInPercentage <= 20) {
      return ProbabilityOfFailure.RARE;
    }
    if (yearsInPercentage <= 40) {
      return ProbabilityOfFailure.UNLIKELY;
    }
    if (yearsInPercentage <= 60) {
      return ProbabilityOfFailure.POSSIBLE;
    }
    if (yearsInPercentage <= 80) {
      return ProbabilityOfFailure.LIKELY;
    }
    if (yearsInPercentage <= 100){
      return ProbabilityOfFailure.VERY_LIKELY;
    }

    return ProbabilityOfFailure.NONE;
  }

  categorizeCorrosionRate(rate: number): ProbabilityOfFailure {
    if(rate == null) {
      return null
    }
    if (rate <= 25) {
      return ProbabilityOfFailure.RARE;
    } else if (rate <= 50) {
      return ProbabilityOfFailure.UNLIKELY;
    } else if (rate <= 75) {
      return ProbabilityOfFailure.POSSIBLE;
    } else if (rate <= 100) {
      return ProbabilityOfFailure.LIKELY;
    } else {
      return ProbabilityOfFailure.VERY_LIKELY;
    }
  }

  categorizeAnomalies(percentage: number): ProbabilityOfFailure {
    if(percentage == null) {
      return null
    }
    if (percentage >= 100) {
      return ProbabilityOfFailure.VERY_LIKELY;
    } else if (percentage >= 80) {
      return ProbabilityOfFailure.LIKELY;
    } else if (percentage >= 60) {
      return ProbabilityOfFailure.POSSIBLE;
    } else if (percentage >= 40) {
      return ProbabilityOfFailure.UNLIKELY;
    } else {
      return ProbabilityOfFailure.RARE;
    }
  }

  categorizeDesign(probabilityOfFailure: number): ProbabilityOfFailure {
    if (probabilityOfFailure == null || probabilityOfFailure <= 0) {
      return ProbabilityOfFailure.NONE;
    } else if (probabilityOfFailure <= 20) {
        return ProbabilityOfFailure.RARE;
    } else if (probabilityOfFailure <= 40) {
        return ProbabilityOfFailure.UNLIKELY;
    } else if (probabilityOfFailure <= 60) {
        return ProbabilityOfFailure.POSSIBLE;
    } else if (probabilityOfFailure <= 80) {
        return ProbabilityOfFailure.LIKELY;
    } else {
        return ProbabilityOfFailure.VERY_LIKELY;
    }
  }

  getPercentageFromPof(probabilityOfFailure: ProbabilityOfFailure): number | null {
    switch(probabilityOfFailure) {
      case ProbabilityOfFailure.VERY_LIKELY: return 100;
      case ProbabilityOfFailure.LIKELY: return 80;
      case ProbabilityOfFailure.POSSIBLE: return 60;
      case ProbabilityOfFailure.UNLIKELY: return 40;
      case ProbabilityOfFailure.RARE: return 20;
      default: return 0;
    }
  }

  // categorizeByReason(reason: IReasons, origin: string): ProbabilityOfFailure {

  //   if(reason == null) {
  //     return ProbabilityOfFailure.NONE;
  //   }
  //   const {reasonName, probabilityOfFailure} = reason

  //   if(origin.toLowerCase() == "design"){
  //     return this.categorizeDesign(probabilityOfFailure)
  //   }


  //   switch (reasonName) {
  //     case 'Fatigue':
  //     case 'Buckling':
  //     case 'Yielding':
  //       return this.categorizeFEA(probabilityOfFailure, reasonName);
  //     case 'Corrosion Rate':
  //       return this.categorizeCorrosionRate(probabilityOfFailure);
  //     case 'Relative Degradation':
  //       return this.categorizeRelativeDegradation(probabilityOfFailure);
  //     case 'Remaining Life':
  //       return this.categorizeRemainingLife(probabilityOfFailure);
  //     default:
  //       return ProbabilityOfFailure.NONE;
  //   }
  // }
}
